import { TextMaterialTag, TextMaterialTagInput } from '@@partner:types:app'
import { gql, useMutation } from '@apollo/client'



export interface UpdateTextMaterialTag {
  updateTextMaterialTag: TextMaterialTag
}

export interface UpdateTextMaterialTagVariables {
  textMaterialTagInfo: TextMaterialTagInput;
  upsert: boolean;
}

export const GQL_MUTATION_UPDATE_TEXT_MATERIAL_TAG = gql`
  mutation($textMaterialTagInfo: TextMaterialTagInput!, $upsert: Boolean) {
    updateTextMaterialTag(textMaterialTagInfo: $textMaterialTagInfo, upsert: $upsert) {
      id
      name
      slug
      title
      created_at
      updated_at
    }
  }
`

export const useMutateUpdateTextMaterialTag = () =>
  useMutation<UpdateTextMaterialTag, UpdateTextMaterialTagVariables>(
    GQL_MUTATION_UPDATE_TEXT_MATERIAL_TAG
  )